<template>
  <Background
    :bgColor="bgColor">
    <Container>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-[1fr_30%] gap-20px">
        <div>
          <Title
            :headingTag="'h2'"
            :style="'h2'"
            bottomSpacing>
            <slot name="title">Section Title</slot>
          </Title>
          <Paragraphs
            :listStyle="listStyle">
            <slot name="body"><p>I love cheese, especially boursin bocconcini. Red leicester camembert de normandie the big cheese babybel blue castello cheese and biscuits swiss paneer. Squirty cheese goat cheddar queso blue castello cheese and wine squirty cheese cauliflower cheese. Monterey jack cow fromage frais the big cheese chalk and cheese when the cheese comes out everybody's happy cheesy feet rubber cheese. Croque monsieur st. agur blue cheese.</p></slot>
          </Paragraphs>
        </div>
        <div>
            <slot name="content">
              <div class="bg-light-gray-700 w-72 h-72"></div>
            </slot>
        </div>
      </div>
    </Container>
  </Background>
</template>

<script>
import Background from '../Atoms/Background.vue';
import Container from '../Atoms/Container.vue';
import Title from '../Atoms/Heading.vue';
import Paragraphs from '../Atoms/Paragraphs.vue';

import { useCustomValidator, useIsBgColor } from '../../compostables/useValidators';
import useHasSlot from '../../compostables/useHasSlot';

export default {
  components: {
    Background,
    Container,
    Paragraphs,
    Title
  },

  props: {
    bgColor: {
      type: String,
      required: false,
      default: 'white',
      // validator(value) {
      //     return useIsBgColor(value);
      // }
    },
    imgPosition: {
      type: String,
      required: false,
      default: "right",
      // validator(value) {
      //     return useCustomValidator(['right', 'left', 'bottom'], value);
      // }
    },
    listStyle: {
      type: String,
      required: false,
      default: null,
    }
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);

    return {
      hasSlot
    }
  }
}
</script>

<style>

</style>